var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({staticStyle:{"width":"100px"},attrs:{"value":_vm.value,"size":"mini","disabled":_vm.disabled},on:{"change":_vm.changeEvent}},'el-select',_vm.props,false),_vm._l((_vm.list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }